module.exports = __webpack_public_path__ + "static/media/christian-dior-miss-dior-big.ab6c54d3.png";